







































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
@Component
export default class BlankSpace extends Vue {
  @Prop({
    type: Boolean,
    default: () => false
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'blankSpace',
        height: 5,
        color: '#f3f3f3'
      }
    }
  })
  BlankSpaceConfig!: any
}
